import { Validator } from '../../types/Validator';

const errorCode = 'INVALID_LAND_LINE';
const regexp = RegExp(/^\+57[1-9]{1}[0-9]{6}$/);

const validateLandLine: Validator = value => {
  const isEmpty = String(value).trim() === '';
  const isValid = regexp.test(String(value).replace(/[\s-]/g, ''));
  return value === undefined || isEmpty || isValid ? undefined : { errorCode };
};

export { errorCode, validateLandLine };
